import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'apollo',
  `
    STORAGE_SAVE_INIT
    STORAGE_SAVE_SUCCESS
    STORAGE_SAVE_ERROR

    APOLLO_LINK_STATE_SYNC
  `
);
